/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Country User Role Constants
 */

// Generic actions
export const GET_ALL_COUNTRY_USER_ROLES = 'Roles/GET_ALL_COUNTRY_USER_ROLES';
export const GET_COUNTRY_USER_ROLE_BY_ID = 'Roles/GET_COUNTRY_USER_ROLE_BY_ID';
export const CREATE_COUNTRY_USER_ROLE = 'Roles/CREATE_COUNTRY_USER_ROLE';
export const UPDATE_COUNTRY_USER_ROLE = 'Roles/UPDATE_COUNTRY_USER_ROLE';
export const DELETE_COUNTRY_USER_ROLE_BY_ID =
  'Roles/DELETE_COUNTRY_USER_ROLE_BY_ID';
